import { uniqueId } from "lodash";
import { Children, ReactElement, useEffect, useState } from "react";

export const TabItem = ({
  children,
  label,
}: {
  children: any;
  label: string;
}) => {
  return <div>{children}</div>;
};

export default function Tabs({
  children,
  className,
}: {
  children:
    | Array<React.ReactComponentElement<typeof TabItem>>
    | React.ReactComponentElement<typeof TabItem>;

  className?: string;
}) {
  // Map tabs
  const tabs = Children.map(children, (child, index) => ({
    id: index,
    label: child.props.label,
    children: child.props.children,
  }));

  const [state, setState] = useState({
    currentTabId: 0,
  });

  const currentTab = tabs.find((t) => t.id == state.currentTabId);

  return (
    <div className={`tab-wizard ${className}`}>
      <div className="tab-swaps border-b border-b-neutral-gray-100 dark:border-b-neutral-gray-800">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setState((s) => ({ ...s, currentTabId: t.id }))}
            className={`px-3 pb-3 border-b-4 -mb-px text-base font-bold text-neutral-gray-600 dark:text-neutral-gray-800 ${
              t.id === state.currentTabId
                ? "border-b-primary-blue-400 text-neutral-gray-800 dark:text-neutral-gray-50!"
                : "border-b-transparent"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="tab-panes py-8">{currentTab?.children}</div>
    </div>
  );
}
